export function getUrlPathname(url: string) {
  if (url.length === 0) {
    return "";
  }

  const tokens = url.replace(/\\/g, "/").split("/");

  return tokens[tokens.length - 1];
}
